// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1mrfU","footer":"Form_footer__2UGHc"};